import React, { useState } from 'react';
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

//Images
import slide3 from '../../../../assets/dist/img/slide3.jpg';
import slide4 from '../../../../assets/dist/img/slide4.jpg';

const Body = () => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="hk-pg-body">
            <Container>
                <Row>
                <Col xl={5} lg={6} md={7} sm={10} className="position-relative mx-auto v-separator">
                        <div className="auth-content py-md-0 py-8">
                            <Form className="w-100">
                                <Row>
                                    <Col lg={10} className="mx-auto">
                                        <h4 className="text-center mb-4">Sign Up to Stuut</h4>
                                        <Button variant="outline-dark" className="btn-rounded btn-block mb-3">
                                            <span>
                                                <span className="icon">
                                                    <FontAwesomeIcon icon={faGoogle} />
                                                </span>
                                                <span>Sign Up with Gmail</span>
                                            </span>
                                        </Button>
                                        <Button variant="social-facebook" className="btn-social btn-rounded btn-block">
                                            <span>
                                                <span className="icon">
                                                    <FontAwesomeIcon icon={faFacebook} />
                                                </span>
                                                <span>Sign Up with Facebook</span>
                                            </span>
                                        </Button>
                                        <div className="title-sm title-wth-divider divider-center my-4"><span>Or</span></div>
                                        <Row className="gx-3">
                                            <Col lg={6} as={Form.Group} className="mb-3">
                                                <Form.Label>First Name</Form.Label>
                                                <Form.Control placeholder="Enter your first name" type="text" />
                                            </Col>
                                            <Col lg={6} as={Form.Group} className="mb-3">
                                                <Form.Label>Last Name</Form.Label>
                                                <Form.Control placeholder="Enter your last name" type="text" />
                                            </Col>
                                            <Col lg={12} as={Form.Group} className="mb-3">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control placeholder="Enter your email" type="text" />
                                            </Col>
                                            <Col lg={12} as={Form.Group} className="mb-3">
                                                <Form.Label>Password</Form.Label>
                                                <InputGroup className="password-check">
                                                    <span className="input-affix-wrapper affix-wth-text">
                                                        <Form.Control placeholder="6+ characters" type={showPassword ? "text" : "password"} />
                                                        <Link to="#" className="input-suffix text-primary text-uppercase fs-8 fw-medium" onClick={() => setShowPassword(!showPassword)} >
                                                            {showPassword
                                                                ?
                                                                <span>Hide</span>
                                                                :
                                                                <span>Show</span>
                                                            }
                                                        </Link>
                                                    </span>
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                        <Form.Check id="logged_in" className="form-check-sm mb-3" >
                                            <Form.Check.Input type="checkbox" defaultChecked />
                                            <Form.Check.Label className="text-muted fs-7">
                                                By creating an account you confirm that you have read and agree with our <Link to="#">Tearms of use</Link> and <Link to="#">Privacy policy</Link>. We may keep you informed about latest updates through our default <Link to="#">notification settings</Link>
                                            </Form.Check.Label>
                                        </Form.Check>
                                        <Button variant='primary' className="btn-rounded btn-uppercase btn-block" as={Link} to="../apps/integrations/integration" >Create account</Button>
                                        <p className="p-xs mt-2 text-center">Already a member ? <Link to="login"><u>Sign In</u></Link></p>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Col>
                <Col xl={7} lg={6} className="d-lg-block d-none ">
                        <div className="auth-content py-md-0  py-8">
                            <Row>
                                <Col xxl={9} xl={8} lg={11} className="mx-auto">
                                    <div className="text-center">
                                        <h3 className="mb-2">The AI-powered, autonomous A/R collections system for the modern org.</h3>
                                        <p>Start your <mark>14days free</mark> trial.</p>
                                    </div>
                                    <ul className="list-icon mt-4">
                                        <li className="mb-1">
                                            <p>
                                                <i className="ri-check-fill text-success" />
                                                <span>Stuut understands your whole business stack from horizontally and vertically. Instead of telling you there’s an error, we’ll fix it for you. </span></p>
                                        </li>
                                        <li className="mb-1">
                                            <p>
                                                <i className="ri-check-fill text-success" />
                                                <span>Get paid instantly with our simplified payment handling, supply chain financing, and ease of handling multi-currency.</span>
                                            </p>
                                        </li>
                                    </ul>
                                    <Row className="gx-3 mt-7">
                                        <Col lg={6}>
                                            <Card className="card-shadow">
                                                <Card.Img variant="top" src={slide3} alt="Card img cap" />
                                                <Card.Body>
                                                    <Card.Title className="text-uppercase">Copy Thoughts?</Card.Title>
                                                    <Card.Text>Any good copy thoughts? I'll prep images after.</Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col lg={6}>
                                            <Card className="card-shadow">
                                                <Card.Img variant="top" src={slide4} alt="Card img cap" />
                                                <Card.Body>
                                                    <Card.Title className="text-uppercase">Copy Thoughts?</Card.Title>
                                                    <Card.Text>Any good copy thoughts? I'll prep images after.</Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                    
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    
                </Row>
            </Container>
        </div>
    )
}

export default Body
